// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.PatientAddressPopup-module__font-s-10___sz3hf {
  font-size: 10px !important;
}

.PatientAddressPopup-module__font-s-12___R_j3r {
  font-size: 12px !important;
}

.PatientAddressPopup-module__font-s-13___LOxq8 {
  font-size: 13px !important;
}

.PatientAddressPopup-module__font-s-14___EgEyx {
  font-size: 14px !important;
}

.PatientAddressPopup-module__font-s-15___WgdpC {
  font-size: 15px !important;
}

.PatientAddressPopup-module__font-s-16___AAXGC {
  font-size: 16px !important;
}

.PatientAddressPopup-module__font-s-18___ThSlf {
  font-size: 18px !important;
}

.PatientAddressPopup-module__font-s-20___p4Szb {
  font-size: 20px !important;
}

.PatientAddressPopup-module__font-s-22___n9WZl {
  font-size: 22px !important;
}

.PatientAddressPopup-module__font-s-28___lFn_F {
  font-size: 28px !important;
}

.PatientAddressPopup-module__font-w-400___iu8Ug {
  font-weight: 400 !important;
}

.PatientAddressPopup-module__font-w-500___hu339 {
  font-weight: 500 !important;
}

.PatientAddressPopup-module__font-w-600___bGB0o {
  font-weight: 600 !important;
}

.PatientAddressPopup-module__font-w-700___xyBJ2 {
  font-weight: 700 !important;
}

.PatientAddressPopup-module__p-5___31yLP {
  padding: 5px !important;
}

.PatientAddressPopup-module__p-12___oCXhh {
  padding: 12px !important;
}

.PatientAddressPopup-module__p-16___Ll302 {
  padding: 16px !important;
}

.PatientAddressPopup-module__p-30___Vpx2S {
  padding: 30px !important;
}

.PatientAddressPopup-module__p-b-0___nMkcx {
  padding-bottom: 0 !important;
}

.PatientAddressPopup-module__p-b-5___GpkaF {
  padding-bottom: 5px !important;
}

.PatientAddressPopup-module__p-b-10___i1H_s {
  padding-bottom: 10px !important;
}

.PatientAddressPopup-module__p-b-12___M6N5A {
  padding-bottom: 12px !important;
}

.PatientAddressPopup-module__p-b-16___qPUUI {
  padding-bottom: 16px !important;
}

.PatientAddressPopup-module__p-b-18___isGFR {
  padding-bottom: 18px !important;
}

.PatientAddressPopup-module__p-b-20___YwjDL {
  padding-bottom: 20px !important;
}

.PatientAddressPopup-module__p-b-25___O9nVi {
  padding-bottom: 25px !important;
}

.PatientAddressPopup-module__p-b-30___Wz31z {
  padding-bottom: 30px !important;
}

.PatientAddressPopup-module__p-b-50___JJ_Lp {
  padding-bottom: 50px !important;
}

.PatientAddressPopup-module__p-t-0___bQvCr {
  padding-top: 0 !important;
}

.PatientAddressPopup-module__p-t-12___aRXDy {
  padding-top: 12px !important;
}

.PatientAddressPopup-module__p-t-16___y0SIe {
  padding-top: 16px !important;
}

.PatientAddressPopup-module__p-t-18___wAZku {
  padding-top: 18px !important;
}

.PatientAddressPopup-module__p-t-20___Dw7xQ {
  padding-top: 20px !important;
}

.PatientAddressPopup-module__p-t-30___PUSzr {
  padding-top: 30px !important;
}

.PatientAddressPopup-module__p-t-40___NPV36 {
  padding-top: 40px !important;
}

.PatientAddressPopup-module__p-t-50____3VSS {
  padding-top: 50px !important;
}

.PatientAddressPopup-module__p-l-20___PskLW {
  padding-left: 20px !important;
}

.PatientAddressPopup-module__p-l-30___qHkzh {
  padding-left: 30px !important;
}

.PatientAddressPopup-module__p-l-40___eiV48 {
  padding-left: 40px !important;
}

.PatientAddressPopup-module__p-r-16___rTm12 {
  padding-right: 16px !important;
}

.PatientAddressPopup-module__p-r-20____32C2 {
  padding-right: 20px !important;
}

.PatientAddressPopup-module__p-r-30___TmUQo {
  padding-right: 30px !important;
}

.PatientAddressPopup-module__p-r-50___ifTgB {
  padding-right: 50px !important;
}

.PatientAddressPopup-module__p-r-60___Y5n0C {
  padding-right: 60px !important;
}

.PatientAddressPopup-module__m-b-1___DAOhb {
  margin-bottom: 1px !important;
}

.PatientAddressPopup-module__m-b-2___j3OXO {
  margin-bottom: 2px !important;
}

.PatientAddressPopup-module__m-b-6___gQ9jz {
  margin-bottom: 6px !important;
}

.PatientAddressPopup-module__m-b-8___IrTaz {
  margin-bottom: 8px !important;
}

.PatientAddressPopup-module__m-b-10___UhdK1 {
  margin-bottom: 10px !important;
}

.PatientAddressPopup-module__m-b-14___bUgf3 {
  margin-bottom: 14px !important;
}

.PatientAddressPopup-module__m-b-16___hyFwi {
  margin-bottom: 16px !important;
}

.PatientAddressPopup-module__m-b-20____0PJB {
  margin-bottom: 20px !important;
}

.PatientAddressPopup-module__m-b-22___NhoLf {
  margin-bottom: 22px !important;
}

.PatientAddressPopup-module__m-b-24___pJxRY {
  margin-bottom: 24px !important;
}

.PatientAddressPopup-module__m-b-30___uZ6Zb {
  margin-bottom: 30px !important;
}

.PatientAddressPopup-module__m-b-32___FazyO {
  margin-bottom: 32px !important;
}

.PatientAddressPopup-module__m-b-40___Wph92 {
  margin-bottom: 40px !important;
}

.PatientAddressPopup-module__m-t-2___dS5sN {
  margin-top: 2px !important;
}

.PatientAddressPopup-module__m-t-3___qanDm {
  margin-top: 3px !important;
}

.PatientAddressPopup-module__m-t-4___UEGyS {
  margin-top: 4px !important;
}

.PatientAddressPopup-module__m-t-5___C1Djd {
  margin-top: 5px !important;
}

.PatientAddressPopup-module__m-t-8___vmpf2 {
  margin-top: 8px !important;
}

.PatientAddressPopup-module__m-t-10___IX7Kg {
  margin-top: 10px !important;
}

.PatientAddressPopup-module__m-t-15___rsqyu {
  margin-top: 15px !important;
}

.PatientAddressPopup-module__m-t-16___ZNDqa {
  margin-top: 16px !important;
}

.PatientAddressPopup-module__m-t-20___m9uYe {
  margin-top: 20px !important;
}

.PatientAddressPopup-module__m-t-22___W_QFb {
  margin-top: 22px !important;
}

.PatientAddressPopup-module__m-t-30___rn6mB {
  margin-top: 30px !important;
}

.PatientAddressPopup-module__m-t-32___Zlvhh {
  margin-top: 32px !important;
}

.PatientAddressPopup-module__m-l-auto___dBIM4 {
  margin-left: auto !important;
}

.PatientAddressPopup-module__m-l-4___dymXS {
  margin-left: 4px !important;
}

.PatientAddressPopup-module__m-l-5___Lgevu {
  margin-left: 5px !important;
}

.PatientAddressPopup-module__m-l-6___pnqIe {
  margin-left: 6px !important;
}

.PatientAddressPopup-module__m-l-8___X1KQY {
  margin-left: 8px !important;
}

.PatientAddressPopup-module__m-l-10___UFzUF {
  margin-left: 10px !important;
}

.PatientAddressPopup-module__m-l-16___UxnG6 {
  margin-left: 16px !important;
}

.PatientAddressPopup-module__m-l-20___OJA07 {
  margin-left: 20px !important;
}

.PatientAddressPopup-module__m-l-24___UcrGh {
  margin-left: 24px !important;
}

.PatientAddressPopup-module__m-l-30___pzQ07 {
  margin-left: 30px !important;
}

.PatientAddressPopup-module__m-l-35____OvpY {
  margin-left: 35px !important;
}

.PatientAddressPopup-module__m-l-40___PrCXZ {
  margin-left: 40px !important;
}

.PatientAddressPopup-module__m-r-8___IfFNb {
  margin-right: 8px !important;
}

.PatientAddressPopup-module__m-r-10___s7EIs {
  margin-right: 10px !important;
}

.PatientAddressPopup-module__m-r-16___Tc9yR {
  margin-right: 16px !important;
}

.PatientAddressPopup-module__m-r-20___hwRjt {
  margin-right: 20px !important;
}

.PatientAddressPopup-module__m-r-24___ohIXZ {
  margin-right: 24px !important;
}

.PatientAddressPopup-module__m-r-30___fbJzy {
  margin-right: 30px !important;
}

.PatientAddressPopup-module__m-r-40___rGLjt {
  margin-right: 40px !important;
}

.PatientAddressPopup-module__border-r-3___Gk6kz {
  border-radius: 3px !important;
}

.PatientAddressPopup-module__border-r-4___EcYLI {
  border-radius: 4px !important;
}

.PatientAddressPopup-module__border-r-6___KMhhu {
  border-radius: 6px !important;
}

.PatientAddressPopup-module__border-r-10____wB0K {
  border-radius: 10px !important;
}

.PatientAddressPopup-module__border-r-12___j1lTz {
  border-radius: 12px !important;
}

.PatientAddressPopup-module__border-r-16___qd6vB {
  border-radius: 16px !important;
}

.PatientAddressPopup-module__border-r-50___nHJNl {
  border-radius: 50% !important;
}

.PatientAddressPopup-module__primary-border___zDIMl {
  border: 1px solid rgba(91, 91, 91, 0.2);
}

.PatientAddressPopup-module__primary-border-b___pqVyK {
  border-bottom: 1px solid rgba(91, 91, 91, 0.2);
}

.PatientAddressPopup-module__primary-border-t___Zo0OQ {
  border-top: 1px solid rgba(91, 91, 91, 0.2);
}

.PatientAddressPopup-module__primary-border-l___hlyxr {
  border-left: 1px solid rgba(91, 91, 91, 0.2);
}

.PatientAddressPopup-module__primary-border-r___hnLxw {
  border-right: 1px solid rgba(91, 91, 91, 0.2);
}

.PatientAddressPopup-module__secondary-border___S8Yc4 {
  border: 1px solid #637768;
}

.PatientAddressPopup-module__secondary-border-b___vWgoi {
  border-bottom: 1px solid #637768;
}

.PatientAddressPopup-module__secondary-border-t___muCJo {
  border-top: 1px solid #637768;
}

.PatientAddressPopup-module__secondary-border-l___Shbfs {
  border-left: 1px solid #637768;
}

.PatientAddressPopup-module__secondary-border-r___XtYV5 {
  border-right: 1px solid #637768;
}

.PatientAddressPopup-module__gap-0___R4iEo {
  gap: 0 !important;
}

.PatientAddressPopup-module__gap-2___RkSg9 {
  gap: 2px !important;
}

.PatientAddressPopup-module__gap-4___OC_Ow {
  gap: 4px !important;
}

.PatientAddressPopup-module__gap-5___fIXKI {
  gap: 5px !important;
}

.PatientAddressPopup-module__gap-6___RrqqL {
  gap: 6px !important;
}

.PatientAddressPopup-module__gap-8___OtcsB {
  gap: 8px !important;
}

.PatientAddressPopup-module__gap-10___z7ceQ {
  gap: 10px !important;
}

.PatientAddressPopup-module__gap-12___ONiGU {
  gap: 12px !important;
}

.PatientAddressPopup-module__gap-14___NWOWh {
  gap: 14px !important;
}

.PatientAddressPopup-module__gap-16___DHpa9 {
  gap: 16px !important;
}

.PatientAddressPopup-module__gap-18___nn6JU {
  gap: 18px !important;
}

.PatientAddressPopup-module__gap-20___NZSo5 {
  gap: 20px !important;
}

.PatientAddressPopup-module__gap-24___WQX0G {
  gap: 24px !important;
}

.PatientAddressPopup-module__gap-26___cYo0u {
  gap: 26px !important;
}

.PatientAddressPopup-module__gap-30___z6hxk {
  gap: 30px !important;
}

.PatientAddressPopup-module__gap-32___wDMIX {
  gap: 32px !important;
}

.PatientAddressPopup-module__gap-40___kw5XO {
  gap: 40px !important;
}

.PatientAddressPopup-module__gap-50___MHZVx {
  gap: 50px !important;
}

.PatientAddressPopup-module__flex-1___HDp3R {
  flex: 1;
}

.PatientAddressPopup-module__flex-none___w3I77 {
  flex: none !important;
}

.PatientAddressPopup-module__flex-column___HMDX_ {
  display: flex;
  flex-direction: column !important;
}

.PatientAddressPopup-module__flex-row___bqAr3 {
  display: flex;
  flex-direction: row !important;
}

.PatientAddressPopup-module__vertically-centered___LgmPA {
  display: flex;
  align-items: center !important;
}

.PatientAddressPopup-module__horizontally-centered___CgaRz {
  display: flex;
  justify-content: center !important;
}

.PatientAddressPopup-module__horizontally-end___kx1cz {
  display: flex;
  justify-content: end !important;
}

.PatientAddressPopup-module__vertically-start___rd8pB {
  display: flex;
  align-items: start !important;
}

.PatientAddressPopup-module__space-between___qTU43 {
  display: flex;
  justify-content: space-between !important;
}

.PatientAddressPopup-module__flex-wrap___PgBh2 {
  flex-wrap: wrap !important;
}

.PatientAddressPopup-module__height-100___Py9cB {
  height: 100%;
}

.PatientAddressPopup-module__width-50___yvT4t {
  width: 50% !important;
}

.PatientAddressPopup-module__width-100___XENnY {
  width: 100%;
}

.PatientAddressPopup-module__cursor-pointer___fwVKi {
  cursor: pointer;
}

.PatientAddressPopup-module__cursor-not-allowed___ap1iQ {
  cursor: not-allowed !important;
}

.PatientAddressPopup-module__absolute-centered___JF5qU {
  top: 50%;
  left: 50%;
  position: absolute;
  transform: translate(-50%, -50%);
}

.PatientAddressPopup-module__absolute___uCFzL {
  position: absolute;
}

.PatientAddressPopup-module__relative___QGRI0 {
  position: relative;
}

.PatientAddressPopup-module__fixed____gAwn {
  position: fixed;
}

.PatientAddressPopup-module__visible___pFg25 {
  opacity: 1;
}

.PatientAddressPopup-module__invisible___ysqZZ {
  opacity: 0;
}

.PatientAddressPopup-module__col-90___N5vay {
  width: 90% !important;
}

.PatientAddressPopup-module__col-auto___wbBCs {
  width: auto !important;
}

.PatientAddressPopup-module__medical-tabs___Eoji6 {
  gap: 30px;
  padding: 0 !important;
  margin: 20px 40px -5px 40px;
}

.PatientAddressPopup-module__medical-table-new___chlOz {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination));
  overflow-y: scroll;
  overflow-x: hidden;
}
.PatientAddressPopup-module__medical-table-new___chlOz:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.PatientAddressPopup-module__medical-table-new___chlOz::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.PatientAddressPopup-module__medical-table-new___chlOz::-webkit-scrollbar-track {
  display: none;
}
.PatientAddressPopup-module__medical-table-new___chlOz.PatientAddressPopup-module__no-pagination___zWtuT {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs));
  overflow-y: scroll;
  overflow-x: hidden;
}
.PatientAddressPopup-module__medical-table-new___chlOz.PatientAddressPopup-module__no-pagination___zWtuT:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.PatientAddressPopup-module__medical-table-new___chlOz.PatientAddressPopup-module__no-pagination___zWtuT::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.PatientAddressPopup-module__medical-table-new___chlOz.PatientAddressPopup-module__no-pagination___zWtuT::-webkit-scrollbar-track {
  display: none;
}

.PatientAddressPopup-module__medical-table-empty___sR6Z5 {
  padding: 14px 40px !important;
}

.PatientAddressPopup-module__icon-btn___WQ87D {
  width: 22px;
  height: 22px;
  cursor: pointer;
}

.PatientAddressPopup-module__search-icon___AvDDm {
  width: 24px;
  height: 24px;
  align-self: center;
}

.PatientAddressPopup-module__disable-select___m6LWf {
  user-select: none;
}

.PatientAddressPopup-module__break-word___oA68q {
  word-break: break-word;
}

.PatientAddressPopup-module__popup-clear-btn___wcRtQ {
  display: flex;
  align-self: center;
  cursor: pointer;
  font-weight: 500;
  font-size: 14px;
  line-height: 150%;
  color: #f06c67;
}

.PatientAddressPopup-module__scroll-m-b-20___P_YOg {
  scroll-margin-bottom: 20px;
}

.PatientAddressPopup-module__input___xzqHU {
  padding: 0 25px 15px 25px;
  min-width: 200px;
}

.PatientAddressPopup-module__secondaryContainer___Tk2vL {
  display: flex;
  flex-direction: row;
  width: 100%;
  z-index: 1;
}

.PatientAddressPopup-module__buttonsContainer___nPJlq {
  display: flex;
  flex-direction: row;
  flex: 1;
  justify-content: center;
  padding: 10px 40px 40px 40px;
}
.PatientAddressPopup-module__buttonsContainer___nPJlq .PatientAddressPopup-module__button___a3bIK {
  display: flex;
  flex: 1;
  margin: 0 1vw;
}`, "",{"version":3,"sources":["webpack://./../common/src/styles/global/_base.scss","webpack://./src/popups/PatientAddressPopup/PatientAddressPopup.module.scss","webpack://./../common/src/styles/global/_mixins.scss"],"names":[],"mappings":"AAIA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADOA;EACE,uBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,yBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,uCAAA;ACNF;;ADSA;EACE,8CAAA;ACNF;;ADSA;EACE,2CAAA;ACNF;;ADSA;EACE,4CAAA;ACNF;;ADSA;EACE,6CAAA;ACNF;;ADSA;EACE,yBAAA;ACNF;;ADSA;EACE,gCAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,+BAAA;ACNF;;ADUA;EACE,iBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,OAAA;ACPF;;ADUA;EACE,qBAAA;ACPF;;ADUA;EACE,aAAA;EACA,iCAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,kCAAA;ACPF;;ADUA;EACE,aAAA;EACA,+BAAA;ACPF;;ADUA;EACE,aAAA;EACA,6BAAA;ACPF;;ADUA;EACE,aAAA;EACA,yCAAA;ACPF;;ADUA;EACE,0BAAA;ACPF;;ADWA;EACE,YAAA;ACRF;;ADWA;EACE,qBAAA;ACRF;;ADWA;EACE,WAAA;ACRF;;ADYA;EACE,eAAA;ACTF;;ADYA;EACE,8BAAA;ACTF;;ADaA;EACE,QAAA;EACA,SAAA;EACA,kBAAA;EACA,gCAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,eAAA;ACVF;;ADcA;EACE,UAAA;ACXF;;ADcA;EACE,UAAA;ACXF;;ADeA;EACE,qBAAA;ACZF;;ADeA;EACE,sBAAA;ACZF;;ADgBA;EACE,SAAA;EACA,qBAAA;EACA,2BAAA;ACbF;;ADgBA;EE5lBE,wLF8lBE;EE7lBF,kBAAA;EACA,kBAAA;ADglBF;AC9kBE;EACE,oCAAA;EACA,mBAAA;ADglBJ;AC7kBE;EACE,UAAA;EACA,6BAAA;AD+kBJ;AC5kBE;EACE,aAAA;AD8kBJ;ADQE;EErmBA,8JFumBI;EEtmBJ,kBAAA;EACA,kBAAA;ADgmBF;AC9lBE;EACE,oCAAA;EACA,mBAAA;ADgmBJ;AC7lBE;EACE,UAAA;EACA,6BAAA;AD+lBJ;AC5lBE;EACE,aAAA;AD8lBJ;;ADGA;EACE,6BAAA;ACAF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,eAAA;ACDF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;ACDF;;ADIA;EACE,iBAAA;ACDF;;ADIA;EACE,sBAAA;ACDF;;ADIA;EACE,aAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;ACDF;;ADIA;EACE,0BAAA;ACDF;;AA3pBA;EACE,yBAAA;EACA,gBAAA;AA8pBF;;AA3pBA;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,UAAA;AA8pBF;;AA3pBA;EACE,aAAA;EACA,mBAAA;EACA,OAAA;EACA,uBAAA;EACA,4BAAA;AA8pBF;AA5pBE;EACE,aAAA;EACA,OAAA;EACA,aAAA;AA8pBJ","sourcesContent":["@use 'mixins';\n@use 'functions';\n\n// font\n.font-s-10 {\n  font-size: 10px !important;\n}\n\n.font-s-12 {\n  font-size: 12px !important;\n}\n\n.font-s-13 {\n  font-size: 13px !important;\n}\n\n.font-s-14 {\n  font-size: 14px !important;\n}\n\n.font-s-15 {\n  font-size: 15px !important;\n}\n\n.font-s-16 {\n  font-size: 16px !important;\n}\n\n.font-s-18 {\n  font-size: 18px !important;\n}\n\n.font-s-20 {\n  font-size: 20px !important;\n}\n\n.font-s-22 {\n  font-size: 22px !important;\n}\n\n.font-s-28 {\n  font-size: 28px !important;\n}\n\n.font-w-400 {\n  font-weight: 400 !important;\n}\n\n.font-w-500 {\n  font-weight: 500 !important;\n}\n\n.font-w-600 {\n  font-weight: 600 !important;\n}\n\n.font-w-700 {\n  font-weight: 700 !important;\n}\n\n// padding\n.p-5 {\n  padding: 5px !important;\n}\n\n.p-12 {\n  padding: 12px !important;\n}\n\n.p-16 {\n  padding: 16px !important;\n}\n\n.p-30 {\n  padding: 30px !important;\n}\n\n.p-b-0 {\n  padding-bottom: 0 !important;\n}\n\n.p-b-5 {\n  padding-bottom: 5px !important;\n}\n\n.p-b-10 {\n  padding-bottom: 10px !important;\n}\n\n.p-b-12 {\n  padding-bottom: 12px !important;\n}\n\n.p-b-16 {\n  padding-bottom: 16px !important;\n}\n\n.p-b-18 {\n  padding-bottom: 18px !important;\n}\n\n.p-b-20 {\n  padding-bottom: 20px !important;\n}\n\n.p-b-25 {\n  padding-bottom: 25px !important;\n}\n\n.p-b-30 {\n  padding-bottom: 30px !important;\n}\n\n.p-b-50 {\n  padding-bottom: 50px !important;\n}\n\n.p-t-0 {\n  padding-top: 0 !important;\n}\n\n.p-t-12 {\n  padding-top: 12px !important;\n}\n\n.p-t-16 {\n  padding-top: 16px !important;\n}\n\n.p-t-18 {\n  padding-top: 18px !important;\n}\n\n.p-t-20 {\n  padding-top: 20px !important;\n}\n\n.p-t-30 {\n  padding-top: 30px !important;\n}\n\n.p-t-40 {\n  padding-top: 40px !important;\n}\n\n.p-t-50 {\n  padding-top: 50px !important;\n}\n\n.p-l-20 {\n  padding-left: 20px !important;\n}\n\n.p-l-30 {\n  padding-left: 30px !important;\n}\n\n.p-l-40 {\n  padding-left: 40px !important;\n}\n\n.p-r-16 {\n  padding-right: 16px !important;\n}\n\n.p-r-20 {\n  padding-right: 20px !important;\n}\n\n.p-r-30 {\n  padding-right: 30px !important;\n}\n\n.p-r-50 {\n  padding-right: 50px !important;\n}\n\n.p-r-60 {\n  padding-right: 60px !important;\n}\n\n// margin\n.m-b-1 {\n  margin-bottom: 1px !important;\n}\n\n.m-b-2 {\n  margin-bottom: 2px !important;\n}\n\n.m-b-6 {\n  margin-bottom: 6px !important;\n}\n\n.m-b-8 {\n  margin-bottom: 8px !important;\n}\n\n.m-b-10 {\n  margin-bottom: 10px !important;\n}\n\n.m-b-14 {\n  margin-bottom: 14px !important;\n}\n\n.m-b-16 {\n  margin-bottom: 16px !important;\n}\n\n.m-b-20 {\n  margin-bottom: 20px !important;\n}\n\n.m-b-22 {\n  margin-bottom: 22px !important;\n}\n\n.m-b-24 {\n  margin-bottom: 24px !important;\n}\n\n.m-b-30 {\n  margin-bottom: 30px !important;\n}\n\n.m-b-32 {\n  margin-bottom: 32px !important;\n}\n\n.m-b-40 {\n  margin-bottom: 40px !important;\n}\n\n.m-t-2 {\n  margin-top: 2px !important;\n}\n\n.m-t-3 {\n  margin-top: 3px !important;\n}\n\n.m-t-4 {\n  margin-top: 4px !important;\n}\n\n.m-t-5 {\n  margin-top: 5px !important;\n}\n\n.m-t-8 {\n  margin-top: 8px !important;\n}\n\n.m-t-10 {\n  margin-top: 10px !important;\n}\n\n.m-t-15 {\n  margin-top: 15px !important;\n}\n\n.m-t-16 {\n  margin-top: 16px !important;\n}\n\n.m-t-20 {\n  margin-top: 20px !important;\n}\n\n.m-t-22 {\n  margin-top: 22px !important;\n}\n\n.m-t-30 {\n  margin-top: 30px !important;\n}\n\n.m-t-32 {\n  margin-top: 32px !important;\n}\n\n.m-l-auto {\n  margin-left: auto !important;\n}\n\n.m-l-4 {\n  margin-left: 4px !important;\n}\n\n.m-l-5 {\n  margin-left: 5px !important;\n}\n\n.m-l-6 {\n  margin-left: 6px !important;\n}\n\n.m-l-8 {\n  margin-left: 8px !important;\n}\n\n.m-l-10 {\n  margin-left: 10px !important;\n}\n\n.m-l-16 {\n  margin-left: 16px !important;\n}\n\n.m-l-20 {\n  margin-left: 20px !important;\n}\n\n.m-l-24 {\n  margin-left: 24px !important;\n}\n\n.m-l-30 {\n  margin-left: 30px !important;\n}\n\n.m-l-35 {\n  margin-left: 35px !important;\n}\n\n.m-l-40 {\n  margin-left: 40px !important;\n}\n\n.m-r-8 {\n  margin-right: 8px !important;\n}\n\n.m-r-10 {\n  margin-right: 10px !important;\n}\n\n.m-r-16 {\n  margin-right: 16px !important;\n}\n\n.m-r-20 {\n  margin-right: 20px !important;\n}\n\n.m-r-24 {\n  margin-right: 24px !important;\n}\n\n.m-r-30 {\n  margin-right: 30px !important;\n}\n\n.m-r-40 {\n  margin-right: 40px !important;\n}\n\n// border\n.border-r-3 {\n  border-radius: 3px !important;\n}\n\n.border-r-4 {\n  border-radius: 4px !important;\n}\n\n.border-r-6 {\n  border-radius: 6px !important;\n}\n\n.border-r-10 {\n  border-radius: 10px !important;\n}\n\n.border-r-12 {\n  border-radius: 12px !important;\n}\n\n.border-r-16 {\n  border-radius: 16px !important;\n}\n\n.border-r-50 {\n  border-radius: 50% !important;\n}\n\n.primary-border {\n  border: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-b {\n  border-bottom: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-t {\n  border-top: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-l {\n  border-left: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-r {\n  border-right: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.secondary-border {\n  border: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-b {\n  border-bottom: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-t {\n  border-top: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-l {\n  border-left: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-r {\n  border-right: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n// flex\n.gap-0 {\n  gap: 0 !important;\n}\n\n.gap-2 {\n  gap: 2px !important;\n}\n\n.gap-4 {\n  gap: 4px !important;\n}\n\n.gap-5 {\n  gap: 5px !important;\n}\n\n.gap-6 {\n  gap: 6px !important;\n}\n\n.gap-8 {\n  gap: 8px !important;\n}\n\n.gap-10 {\n  gap: 10px !important;\n}\n\n.gap-12 {\n  gap: 12px !important;\n}\n\n.gap-14 {\n  gap: 14px !important;\n}\n\n.gap-16 {\n  gap: 16px !important;\n}\n\n.gap-18 {\n  gap: 18px !important;\n}\n\n.gap-20 {\n  gap: 20px !important;\n}\n\n.gap-24 {\n  gap: 24px !important;\n}\n\n.gap-26 {\n  gap: 26px !important;\n}\n\n.gap-30 {\n  gap: 30px !important;\n}\n\n.gap-32 {\n  gap: 32px !important;\n}\n\n.gap-40 {\n  gap: 40px !important;\n}\n\n.gap-50 {\n  gap: 50px !important;\n}\n\n.flex-1 {\n  flex: 1;\n}\n\n.flex-none {\n  flex: none !important;\n}\n\n.flex-column {\n  display: flex;\n  flex-direction: column !important;\n}\n\n.flex-row {\n  display: flex;\n  flex-direction: row !important;\n}\n\n.vertically-centered {\n  display: flex;\n  align-items: center !important;\n}\n\n.horizontally-centered {\n  display: flex;\n  justify-content: center !important;\n}\n\n.horizontally-end {\n  display: flex;\n  justify-content: end !important;\n}\n\n.vertically-start {\n  display: flex;\n  align-items: start !important;\n}\n\n.space-between {\n  display: flex;\n  justify-content: space-between !important;\n}\n\n.flex-wrap {\n  flex-wrap: wrap !important;\n}\n\n// width and height\n.height-100 {\n  height: 100%;\n}\n\n.width-50 {\n  width: 50% !important;\n}\n\n.width-100 {\n  width: 100%;\n}\n\n// cursor\n.cursor-pointer {\n  cursor: pointer;\n}\n\n.cursor-not-allowed {\n  cursor: not-allowed !important;\n}\n\n// position\n.absolute-centered {\n  top: 50%;\n  left: 50%;\n  position: absolute;\n  transform: translate(-50%, -50%);\n}\n\n.absolute {\n  position: absolute;\n}\n\n.relative {\n  position: relative;\n}\n\n.fixed {\n  position: fixed;\n}\n\n// visibility\n.visible {\n  opacity: 1;\n}\n\n.invisible {\n  opacity: 0;\n}\n\n// layout\n.col-90 {\n  width: 90% !important;\n}\n\n.col-auto {\n  width: auto !important;\n}\n\n// medical fragments\n.medical-tabs {\n  gap: 30px;\n  padding: 0 !important;\n  margin: 20px 40px -5px 40px;\n}\n\n.medical-table-new {\n  @include mixins.verticalScroll(\n    calc(\n      100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n          --secondary-navigation\n        ) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination)\n    )\n  );\n\n  &.no-pagination {\n    @include mixins.verticalScroll(\n      calc(\n        100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n            --secondary-navigation\n          ) - var(--patient-details-footer) - var(--table-tabs)\n      )\n    );\n  }\n}\n\n.medical-table-empty {\n  padding: 14px 40px !important;\n}\n\n//\n.icon-btn {\n  width: 22px;\n  height: 22px;\n  cursor: pointer;\n}\n\n.search-icon {\n  width: 24px;\n  height: 24px;\n  align-self: center;\n}\n\n.disable-select {\n  user-select: none;\n}\n\n.break-word {\n  word-break: break-word;\n}\n\n.popup-clear-btn {\n  display: flex;\n  align-self: center;\n  cursor: pointer;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 150%;\n  color: functions.get-color(redNew, medium-dark);\n}\n\n.scroll-m-b-20 {\n  scroll-margin-bottom: 20px;\n}\n","@use 'common-src/styles/global' as *;\n\n.input {\n  padding: 0 25px 15px 25px;\n  min-width: 200px;\n}\n\n.secondaryContainer {\n  display: flex;\n  flex-direction: row;\n  width: 100%;\n  z-index: 1;\n}\n\n.buttonsContainer {\n  display: flex;\n  flex-direction: row;\n  flex: 1;\n  justify-content: center;\n  padding: 10px 40px 40px 40px;\n\n  .button {\n    display: flex;\n    flex: 1;\n    margin: 0 1vw;\n  }\n}\n","@forward 'sizes';\n@forward 'variables';\n\n@mixin clipped-text {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n@mixin verticalScroll($height) {\n  height: $height;\n  overflow-y: scroll;\n  overflow-x: hidden;\n\n  &:hover::-webkit-scrollbar-thumb {\n    background-color: rgb(125, 123, 121);\n    border-radius: 10px;\n  }\n\n  &::-webkit-scrollbar {\n    width: 5px;\n    background-color: transparent;\n  }\n\n  &::-webkit-scrollbar-track {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fontS10": `PatientAddressPopup-module__font-s-10___sz3hf`,
	"fontS12": `PatientAddressPopup-module__font-s-12___R_j3r`,
	"fontS13": `PatientAddressPopup-module__font-s-13___LOxq8`,
	"fontS14": `PatientAddressPopup-module__font-s-14___EgEyx`,
	"fontS15": `PatientAddressPopup-module__font-s-15___WgdpC`,
	"fontS16": `PatientAddressPopup-module__font-s-16___AAXGC`,
	"fontS18": `PatientAddressPopup-module__font-s-18___ThSlf`,
	"fontS20": `PatientAddressPopup-module__font-s-20___p4Szb`,
	"fontS22": `PatientAddressPopup-module__font-s-22___n9WZl`,
	"fontS28": `PatientAddressPopup-module__font-s-28___lFn_F`,
	"fontW400": `PatientAddressPopup-module__font-w-400___iu8Ug`,
	"fontW500": `PatientAddressPopup-module__font-w-500___hu339`,
	"fontW600": `PatientAddressPopup-module__font-w-600___bGB0o`,
	"fontW700": `PatientAddressPopup-module__font-w-700___xyBJ2`,
	"p5": `PatientAddressPopup-module__p-5___31yLP`,
	"p12": `PatientAddressPopup-module__p-12___oCXhh`,
	"p16": `PatientAddressPopup-module__p-16___Ll302`,
	"p30": `PatientAddressPopup-module__p-30___Vpx2S`,
	"pB0": `PatientAddressPopup-module__p-b-0___nMkcx`,
	"pB5": `PatientAddressPopup-module__p-b-5___GpkaF`,
	"pB10": `PatientAddressPopup-module__p-b-10___i1H_s`,
	"pB12": `PatientAddressPopup-module__p-b-12___M6N5A`,
	"pB16": `PatientAddressPopup-module__p-b-16___qPUUI`,
	"pB18": `PatientAddressPopup-module__p-b-18___isGFR`,
	"pB20": `PatientAddressPopup-module__p-b-20___YwjDL`,
	"pB25": `PatientAddressPopup-module__p-b-25___O9nVi`,
	"pB30": `PatientAddressPopup-module__p-b-30___Wz31z`,
	"pB50": `PatientAddressPopup-module__p-b-50___JJ_Lp`,
	"pT0": `PatientAddressPopup-module__p-t-0___bQvCr`,
	"pT12": `PatientAddressPopup-module__p-t-12___aRXDy`,
	"pT16": `PatientAddressPopup-module__p-t-16___y0SIe`,
	"pT18": `PatientAddressPopup-module__p-t-18___wAZku`,
	"pT20": `PatientAddressPopup-module__p-t-20___Dw7xQ`,
	"pT30": `PatientAddressPopup-module__p-t-30___PUSzr`,
	"pT40": `PatientAddressPopup-module__p-t-40___NPV36`,
	"pT50": `PatientAddressPopup-module__p-t-50____3VSS`,
	"pL20": `PatientAddressPopup-module__p-l-20___PskLW`,
	"pL30": `PatientAddressPopup-module__p-l-30___qHkzh`,
	"pL40": `PatientAddressPopup-module__p-l-40___eiV48`,
	"pR16": `PatientAddressPopup-module__p-r-16___rTm12`,
	"pR20": `PatientAddressPopup-module__p-r-20____32C2`,
	"pR30": `PatientAddressPopup-module__p-r-30___TmUQo`,
	"pR50": `PatientAddressPopup-module__p-r-50___ifTgB`,
	"pR60": `PatientAddressPopup-module__p-r-60___Y5n0C`,
	"mB1": `PatientAddressPopup-module__m-b-1___DAOhb`,
	"mB2": `PatientAddressPopup-module__m-b-2___j3OXO`,
	"mB6": `PatientAddressPopup-module__m-b-6___gQ9jz`,
	"mB8": `PatientAddressPopup-module__m-b-8___IrTaz`,
	"mB10": `PatientAddressPopup-module__m-b-10___UhdK1`,
	"mB14": `PatientAddressPopup-module__m-b-14___bUgf3`,
	"mB16": `PatientAddressPopup-module__m-b-16___hyFwi`,
	"mB20": `PatientAddressPopup-module__m-b-20____0PJB`,
	"mB22": `PatientAddressPopup-module__m-b-22___NhoLf`,
	"mB24": `PatientAddressPopup-module__m-b-24___pJxRY`,
	"mB30": `PatientAddressPopup-module__m-b-30___uZ6Zb`,
	"mB32": `PatientAddressPopup-module__m-b-32___FazyO`,
	"mB40": `PatientAddressPopup-module__m-b-40___Wph92`,
	"mT2": `PatientAddressPopup-module__m-t-2___dS5sN`,
	"mT3": `PatientAddressPopup-module__m-t-3___qanDm`,
	"mT4": `PatientAddressPopup-module__m-t-4___UEGyS`,
	"mT5": `PatientAddressPopup-module__m-t-5___C1Djd`,
	"mT8": `PatientAddressPopup-module__m-t-8___vmpf2`,
	"mT10": `PatientAddressPopup-module__m-t-10___IX7Kg`,
	"mT15": `PatientAddressPopup-module__m-t-15___rsqyu`,
	"mT16": `PatientAddressPopup-module__m-t-16___ZNDqa`,
	"mT20": `PatientAddressPopup-module__m-t-20___m9uYe`,
	"mT22": `PatientAddressPopup-module__m-t-22___W_QFb`,
	"mT30": `PatientAddressPopup-module__m-t-30___rn6mB`,
	"mT32": `PatientAddressPopup-module__m-t-32___Zlvhh`,
	"mLAuto": `PatientAddressPopup-module__m-l-auto___dBIM4`,
	"mL4": `PatientAddressPopup-module__m-l-4___dymXS`,
	"mL5": `PatientAddressPopup-module__m-l-5___Lgevu`,
	"mL6": `PatientAddressPopup-module__m-l-6___pnqIe`,
	"mL8": `PatientAddressPopup-module__m-l-8___X1KQY`,
	"mL10": `PatientAddressPopup-module__m-l-10___UFzUF`,
	"mL16": `PatientAddressPopup-module__m-l-16___UxnG6`,
	"mL20": `PatientAddressPopup-module__m-l-20___OJA07`,
	"mL24": `PatientAddressPopup-module__m-l-24___UcrGh`,
	"mL30": `PatientAddressPopup-module__m-l-30___pzQ07`,
	"mL35": `PatientAddressPopup-module__m-l-35____OvpY`,
	"mL40": `PatientAddressPopup-module__m-l-40___PrCXZ`,
	"mR8": `PatientAddressPopup-module__m-r-8___IfFNb`,
	"mR10": `PatientAddressPopup-module__m-r-10___s7EIs`,
	"mR16": `PatientAddressPopup-module__m-r-16___Tc9yR`,
	"mR20": `PatientAddressPopup-module__m-r-20___hwRjt`,
	"mR24": `PatientAddressPopup-module__m-r-24___ohIXZ`,
	"mR30": `PatientAddressPopup-module__m-r-30___fbJzy`,
	"mR40": `PatientAddressPopup-module__m-r-40___rGLjt`,
	"borderR3": `PatientAddressPopup-module__border-r-3___Gk6kz`,
	"borderR4": `PatientAddressPopup-module__border-r-4___EcYLI`,
	"borderR6": `PatientAddressPopup-module__border-r-6___KMhhu`,
	"borderR10": `PatientAddressPopup-module__border-r-10____wB0K`,
	"borderR12": `PatientAddressPopup-module__border-r-12___j1lTz`,
	"borderR16": `PatientAddressPopup-module__border-r-16___qd6vB`,
	"borderR50": `PatientAddressPopup-module__border-r-50___nHJNl`,
	"primaryBorder": `PatientAddressPopup-module__primary-border___zDIMl`,
	"primaryBorderB": `PatientAddressPopup-module__primary-border-b___pqVyK`,
	"primaryBorderT": `PatientAddressPopup-module__primary-border-t___Zo0OQ`,
	"primaryBorderL": `PatientAddressPopup-module__primary-border-l___hlyxr`,
	"primaryBorderR": `PatientAddressPopup-module__primary-border-r___hnLxw`,
	"secondaryBorder": `PatientAddressPopup-module__secondary-border___S8Yc4`,
	"secondaryBorderB": `PatientAddressPopup-module__secondary-border-b___vWgoi`,
	"secondaryBorderT": `PatientAddressPopup-module__secondary-border-t___muCJo`,
	"secondaryBorderL": `PatientAddressPopup-module__secondary-border-l___Shbfs`,
	"secondaryBorderR": `PatientAddressPopup-module__secondary-border-r___XtYV5`,
	"gap0": `PatientAddressPopup-module__gap-0___R4iEo`,
	"gap2": `PatientAddressPopup-module__gap-2___RkSg9`,
	"gap4": `PatientAddressPopup-module__gap-4___OC_Ow`,
	"gap5": `PatientAddressPopup-module__gap-5___fIXKI`,
	"gap6": `PatientAddressPopup-module__gap-6___RrqqL`,
	"gap8": `PatientAddressPopup-module__gap-8___OtcsB`,
	"gap10": `PatientAddressPopup-module__gap-10___z7ceQ`,
	"gap12": `PatientAddressPopup-module__gap-12___ONiGU`,
	"gap14": `PatientAddressPopup-module__gap-14___NWOWh`,
	"gap16": `PatientAddressPopup-module__gap-16___DHpa9`,
	"gap18": `PatientAddressPopup-module__gap-18___nn6JU`,
	"gap20": `PatientAddressPopup-module__gap-20___NZSo5`,
	"gap24": `PatientAddressPopup-module__gap-24___WQX0G`,
	"gap26": `PatientAddressPopup-module__gap-26___cYo0u`,
	"gap30": `PatientAddressPopup-module__gap-30___z6hxk`,
	"gap32": `PatientAddressPopup-module__gap-32___wDMIX`,
	"gap40": `PatientAddressPopup-module__gap-40___kw5XO`,
	"gap50": `PatientAddressPopup-module__gap-50___MHZVx`,
	"flex1": `PatientAddressPopup-module__flex-1___HDp3R`,
	"flexNone": `PatientAddressPopup-module__flex-none___w3I77`,
	"flexColumn": `PatientAddressPopup-module__flex-column___HMDX_`,
	"flexRow": `PatientAddressPopup-module__flex-row___bqAr3`,
	"verticallyCentered": `PatientAddressPopup-module__vertically-centered___LgmPA`,
	"horizontallyCentered": `PatientAddressPopup-module__horizontally-centered___CgaRz`,
	"horizontallyEnd": `PatientAddressPopup-module__horizontally-end___kx1cz`,
	"verticallyStart": `PatientAddressPopup-module__vertically-start___rd8pB`,
	"spaceBetween": `PatientAddressPopup-module__space-between___qTU43`,
	"flexWrap": `PatientAddressPopup-module__flex-wrap___PgBh2`,
	"height100": `PatientAddressPopup-module__height-100___Py9cB`,
	"width50": `PatientAddressPopup-module__width-50___yvT4t`,
	"width100": `PatientAddressPopup-module__width-100___XENnY`,
	"cursorPointer": `PatientAddressPopup-module__cursor-pointer___fwVKi`,
	"cursorNotAllowed": `PatientAddressPopup-module__cursor-not-allowed___ap1iQ`,
	"absoluteCentered": `PatientAddressPopup-module__absolute-centered___JF5qU`,
	"absolute": `PatientAddressPopup-module__absolute___uCFzL`,
	"relative": `PatientAddressPopup-module__relative___QGRI0`,
	"fixed": `PatientAddressPopup-module__fixed____gAwn`,
	"visible": `PatientAddressPopup-module__visible___pFg25`,
	"invisible": `PatientAddressPopup-module__invisible___ysqZZ`,
	"col90": `PatientAddressPopup-module__col-90___N5vay`,
	"colAuto": `PatientAddressPopup-module__col-auto___wbBCs`,
	"medicalTabs": `PatientAddressPopup-module__medical-tabs___Eoji6`,
	"medicalTableNew": `PatientAddressPopup-module__medical-table-new___chlOz`,
	"noPagination": `PatientAddressPopup-module__no-pagination___zWtuT`,
	"medicalTableEmpty": `PatientAddressPopup-module__medical-table-empty___sR6Z5`,
	"iconBtn": `PatientAddressPopup-module__icon-btn___WQ87D`,
	"searchIcon": `PatientAddressPopup-module__search-icon___AvDDm`,
	"disableSelect": `PatientAddressPopup-module__disable-select___m6LWf`,
	"breakWord": `PatientAddressPopup-module__break-word___oA68q`,
	"popupClearBtn": `PatientAddressPopup-module__popup-clear-btn___wcRtQ`,
	"scrollMB20": `PatientAddressPopup-module__scroll-m-b-20___P_YOg`,
	"input": `PatientAddressPopup-module__input___xzqHU`,
	"secondaryContainer": `PatientAddressPopup-module__secondaryContainer___Tk2vL`,
	"buttonsContainer": `PatientAddressPopup-module__buttonsContainer___nPJlq`,
	"button": `PatientAddressPopup-module__button___a3bIK`
};
module.exports = ___CSS_LOADER_EXPORT___;
